import * as React from 'react'

import style from './ExternalLink.style'

type Props = {
  className?: string
}

export type StyleProps = {
  kind: 'small' | 'medium',
}

const styleProps = ({ kind }: StyleProps): StyleProps => ({
  kind: kind || 'medium',
})

const ExternalLink = ({ className }: Props): React.ReactElement<'svg'> => (
  <svg {...{ className }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="nonzero" stroke="#242424">
      <path d="M13 3h8v8M12 12l9-9M18 13.5V18a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h4.5" />
    </g>
  </svg>
)

ExternalLink.defaultProps = {
  className: undefined,
}

export default style(ExternalLink, styleProps)
